import { Button } from "@/components/ui/button";
import { Service } from "@/types/dashboard";
import { useTranslation } from "react-i18next";

interface ServiceActionButtonsProps {
  service: Service;
  onEditService: (service: Service) => void;
  onToggleVisibility?: (service: Service) => void;
  onDeleteClick: () => void;
  isDeleting: boolean;
  isMobile: boolean;
}

export const ServiceActionButtons = ({
  service,
  onEditService,
  onToggleVisibility,
  onDeleteClick,
  isDeleting,
  isMobile
}: ServiceActionButtonsProps) => {
  const { t } = useTranslation();

  if (isMobile) {
    return (
      <>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => onEditService(service)} 
          className="flex-1 text-gray-600 border-gray-300 hover:bg-gray-50"
          disabled={isDeleting}
        >
          {t('common.edit')}
        </Button>
        
        {onToggleVisibility && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onToggleVisibility(service)} 
            className={`flex-1 ${service.is_active ? 'text-green-600 border-green-200 hover:bg-green-50' : 'text-orange-600 border-orange-200 hover:bg-orange-50'}`}
            disabled={isDeleting}
          >
            {service.is_active ? t('common.hide') : t('common.show')}
          </Button>
        )}
        
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onDeleteClick} 
          className="flex-1 text-red-600 border-red-200 hover:bg-red-50"
          disabled={isDeleting}
        >
          {isDeleting ? t('common.deleting') : t('common.delete')}
        </Button>
      </>
    );
  }
  
  return (
    <>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => onEditService(service)} 
        className="text-gray-600 border-gray-300 hover:bg-gray-50"
      >
        {t('common.edit')}
      </Button>
      
      {onToggleVisibility && (
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => onToggleVisibility(service)} 
          className={`${service.is_active ? 'text-green-600 border-green-200 hover:bg-green-50' : 'text-orange-600 border-orange-200 hover:bg-orange-50'}`}
          title={service.is_active ? t('common.hide') + " service" : t('common.show') + " service"}
        >
          {service.is_active ? t('common.hide') : t('common.show')}
        </Button>
      )}
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={onDeleteClick} 
        className="text-red-600 border-red-200 hover:bg-red-50"
        disabled={isDeleting}
      >
        {isDeleting ? t('common.deleting') : t('common.delete')}
      </Button>
    </>
  );
};
